import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationService } from 'primeng/api';
import { NotificationTypes } from 'src/app/app.enums';
import { AuthService, } from 'src/app/Services/auth.service';
import { NotificationsService } from 'src/app/Services/shared/notifications.service';
import { FacebookService } from 'src/app/Services/facebook.service';
import { InstagramService } from 'src/app/Services/instagram.service';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-delete-meta-data',
    templateUrl: './delete-meta-data.component.html',
    styleUrls: ['./delete-meta-data.component.css'],
    standalone: false
})
export class DeleteMetaDataComponent implements OnInit {
    public isAuthenticated: boolean = false;
    public firstName!: string;
    public username!: string;
    public userId!: string;
    public logoImgUrl!: string;
    public password: string = '';
    public Id: string | null = null;
    public platform: string = '';
    public isFacebookAccountDeleteConfirmationDailogVisible: boolean = false;
    public isInstagramAccountDeleteConfirmationDailogVisible: boolean = false;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authService: AuthService,
        private notificationsService: NotificationsService,
        private ngxSpinnerService: NgxSpinnerService,
        private confirmationService: ConfirmationService,
        private facebookService: FacebookService,
        private instagramService: InstagramService,
        private transloco: TranslocoService
    ) { }

    ngOnInit(): void {

        this.isAuthenticated = this.authService.isAuthenticated();
        if (this.isAuthenticated) {
            const currentUser = this.authService.getCurrentUser();
            if (currentUser) {
                this.firstName = currentUser.FirstName.split(' ')[0];
                this.username = currentUser.EmailAddress;
                this.logoImgUrl = currentUser.LogoUrl;
                this.userId = currentUser.UserId;
            }
        }

        // Get platform and Facebook ID from query parameters
        this.route.queryParams.subscribe(params => {
            this.Id = params['Id'];
            this.platform = params['platform'];
        });
    }
    
    public deleteFacebookMetaData(): void {
        // if (this.isFormValid()) {
        //     this.confirmationService.confirm({
        //         message: 'Are you sure you want to delete your account?',
        //         header: 'Confirmation',
        //         icon: 'pi pi-exclamation-triangle',
        //         accept: () => {
        //             this.ngxSpinnerService.show();
        //             this.facebookService.deleteFacebookMetaData(this.Id!, this.username, this.password).subscribe(
        //                 (response) => {
        //                     this.ngxSpinnerService.hide();
        //                     if (response.Success) {
        //                         this.notificationsService.showNotification(
        //                             'Success',
        //                             response.ResponseMessage,
        //                             NotificationTypes.Success
        //                         );
        //                         this.router.navigate(['/']);
        //                     } else {
        //                         this.notificationsService.showNotification(
        //                             'Error',
        //                             response.ResponseMessage,
        //                             NotificationTypes.Error
        //                         );
        //                     }
        //                 },
        //                 (error) => {
        //                     console.error('Error deleting account:', error);
        //                     this.ngxSpinnerService.hide();
        //                     this.notificationsService.showNotification(
        //                         'Error',
        //                         'An error occurred while deleting your account. Please try again later.',
        //                         NotificationTypes.Error
        //                     );
        //                 }
        //             );
        //         }
        //     });
        // } else {
        //     this.notificationsService.showNotification(
        //         'Error',
        //         'Incorrect UserName and Password',
        //         NotificationTypes.Error
        //     );
        // }
        this.isFacebookAccountDeleteConfirmationDailogVisible = true
    }

    public onCloseFacebookMetadataConfirmationDailog(){
        this.isFacebookAccountDeleteConfirmationDailogVisible = false
    }

    public deleteFacebookAccounts(){
        if (this.isFormValid()) {
            // this.confirmationService.confirm({
            //     message: 'Are you sure you want to delete your account?',
            //     header: 'Confirmation',
            //     icon: 'pi pi-exclamation-triangle',
            //     accept: () => {
                    this.ngxSpinnerService.show();
                    this.facebookService.deleteFacebookMetaData(this.username, this.password).subscribe(
                        (response) => {
                            this.ngxSpinnerService.hide();
                            if (response.Success) {
                                this.notificationsService.showNotification(
                                    this.transloco.translate('deleteMetaData.success'),
                                    response.ResponseMessage,
                                    NotificationTypes.Success
                                );
                                this.router.navigate(['/']);
                            } else {
                                this.notificationsService.showNotification(
                                    this.transloco.translate('deleteMetaData.error'),
                                    response.ResponseMessage,
                                    NotificationTypes.Error
                                );
                            }
                        },
                        (error) => {
                            console.error('Error deleting account:', error);
                            this.ngxSpinnerService.hide();
                            this.notificationsService.showNotification(
                                this.transloco.translate('deleteMetaData.error'),
                                this.transloco.translate('deleteMetaData.deleteAccountError'),
                                NotificationTypes.Error
                            );
                        }
                    );
            //     }
            // });
        } else {
            this.notificationsService.showNotification(
                this.transloco.translate('deleteMetaData.error'),
                this.transloco.translate('deleteMetaData.incorrectCredentials'),
                NotificationTypes.Error
            );
        }
    }
    
   

    public isFormValid(): boolean {
        return !!this.username && this.password.length > 0;
    }

}